/**
 * Represents a set of width breakpoints to use for media queries.
 * Reference link: https://www.npmjs.com/package/react-responsive-window
 */
export const breakpoints = {
  desktopLg: 1400,
  desktopMd: 1300,
  desktopSm: 1200,
  tabletLg: 1040,
  tabletMd: 991,
  tabletSm: 840,
  mobileLg: 650,
  mobileMd: 540,
  mobileSm: 400,
};

export type Breakpoint =
  | "desktopLg"
  | "desktopMd"
  | "desktopSm"
  | "tabletLg"
  | "tabletMd"
  | "tabletSm"
  | "mobileLg"
  | "mobileMd"
  | "mobileSm";
